import styled from 'styled-components';

export default styled.div`
  border: 1px solid ${props => props.theme.secondary};
  border-radius: 57px;
  display: flex;
`;
